module.exports = __webpack_public_path__ + "img/banner.adb5c3df.png";